import React from 'react';

const SkeletonLoader = ({ height = "20px", width = "100%", className = "mb-2" }) => {
    return (
        <div 
            className={`bg-secondary ${className}`} 
            style={{ 
                height, 
                width, 
                opacity: 0.1, 
                animation: "pulse 1.5s infinite ease-in-out",
                borderRadius: "4px"
            }} 
        ></div>
    );
};

export default SkeletonLoader;